import { useQuery, useSuspenseQuery } from '@tanstack/react-query';

import { CustomFieldsApi } from '@/lib/api/common/customFields';
import type { CustomField } from '@/lib/api/types/customField';
import { commonQueryKeys } from '@/lib/query-keys/common';

export const getCustomFieldsQueryOptions = () => {
  return {
    queryKey: commonQueryKeys.customFields.all(),
    queryFn: () => CustomFieldsApi.getCustomFields(),
  };
};

export const useGetCustomFieldsQuery = () => {
  return useQuery({
    ...getCustomFieldsQueryOptions(),
  });
};

export const useSuspenseGetCustomFieldsQuery = () => {
  return useSuspenseQuery({
    ...getCustomFieldsQueryOptions(),
  });
};

export const useGetCustomFieldSearchQuery = ({ search }: { search: string }) => {
  return useQuery({
    ...getCustomFieldsQueryOptions(),
    select: (data: CustomField[]) =>
      data.filter((field) => field.name.toLowerCase().includes(search.toLowerCase())),
  });
};

const getCustomFieldDetailsQueryOptions = (customFieldId: number) => {
  return {
    queryKey: commonQueryKeys.customFields.details(customFieldId),
    queryFn: () => CustomFieldsApi.getCustomFieldDetails({ customFieldId }),
    enabled: !!customFieldId,
  };
};

export const useGetCustomFieldDetailsQuery = ({ id }: { id: number }) => {
  return useQuery<CustomField>({
    ...getCustomFieldDetailsQueryOptions(id),
  });
};

export const usePicklistOptionsQuery = ({ customFieldId }: { customFieldId: number }) => {
  return useQuery({
    queryKey: commonQueryKeys.customFields.picklistOptions(customFieldId),
    queryFn: () => CustomFieldsApi.getPicklistOptions({ customFieldId: customFieldId }),
    initialData: [],
    enabled: !!customFieldId,
  });
};
